import { Component, Input } from '@angular/core';
import { IComorbidityDetailed } from 'src/app/interfaces/Comorbidity/IComorbidityDetailed';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzTableModule } from 'ng-zorro-antd/table';
import { TranslateModule } from '@ngx-translate/core';

import { FlexModule } from '@angular/flex-layout';

@Component({
  selector: 'app-comorbidity-expand',
  standalone: true,
  templateUrl: './comorbidity-expand.component.html',
  styleUrls: ['./comorbidity-expand.component.css'],
  imports: [NzLayoutModule, NzTableModule, TranslateModule, FlexModule],
})
export class ComorbidityExpandComponent {
  @Input() item: IComorbidityDetailed = {};
}
